var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2509:3191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99917 0.17071C8.99728 0.155709 8.99542 0.14069 8.98979 0.125689C8.98791 0.120061 8.98605 0.112552 8.98417 0.106925C8.97479 0.0862958 8.96165 0.0675313 8.94665 0.0506484C8.92977 0.0356474 8.91101 0.0225104 8.89038 0.0131369C8.88475 0.0112552 8.87724 0.00750934 8.87161 0.00750934C8.85661 0.00376346 8.84159 0 8.82659 0C8.81908 0 8.81346 0 8.80596 0C8.78908 0 8.77032 0.00374587 8.75343 0.00937348C8.74969 0.0112552 8.74592 0.0112552 8.74218 0.0131194H8.7403L0.113178 3.76112C0.0175092 3.8024 -0.0256299 3.91307 0.0156274 4.00874C0.0325103 4.04813 0.06253 4.08001 0.100042 4.09878L3.2365 5.75892L4.89852 8.89538C4.93041 8.95728 4.99419 8.9948 5.06361 8.99668H5.07112C5.14239 8.9948 5.20618 8.94977 5.2362 8.88412L8.98603 0.25887V0.256988C8.98791 0.253242 8.98791 0.249479 8.98978 0.245733C8.9954 0.22885 8.99915 0.211967 8.99915 0.193203C8.99917 0.185711 9.00103 0.178202 8.99917 0.17071ZM0.621527 3.94683L7.98806 0.744726L3.34341 5.3875L0.621527 3.94683ZM5.05045 8.37576L3.60979 5.65388L8.25256 1.00922L5.05045 8.37576Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2509:3191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.7dc5e839f8e5d92047f3fd73ab88bae1.svg";
export { ForwardRef as ReactComponent };